export default {
    state: {
        products: [],
        total: {},
        services: []
    },
    actions: {
    },
    mutations: {
        setProducts(state, products) {
            state.products = products;
        },
        setTotal(state, total) {
            state.total = total;
        },
        setServices(state, services) {
            state.services = services;
        }
    },
    getters: {
        productsCount(state) {
            return state.products.length;
        },
        products(state) {
            return state.products;
        }
    },
    namespaced: true
}